"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Empty;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Empty(props) {
  var emptyIcon = props.emptyIcon,
      emptyTitle = props.emptyTitle,
      emptyDescription = props.emptyDescription,
      columnsLength = props.columnsLength;
  return _react["default"].createElement("tr", null, _react["default"].createElement("td", {
    colSpan: columnsLength
  }, _react["default"].createElement("div", {
    className: "rainbow-table_body--empty-container"
  }, _react["default"].createElement("span", {
    className: "rainbow-table_body--empty-icon"
  }, emptyIcon), _react["default"].createElement("h1", {
    className: "rainbow-table_body--empty-title"
  }, emptyTitle), _react["default"].createElement("h2", {
    className: "rainbow-table_body--empty-description"
  }, emptyDescription))));
}

Empty.propTypes = {
  columnsLength: _propTypes["default"].number,
  emptyIcon: _propTypes["default"].node,
  emptyTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  emptyDescription: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
Empty.defaultProps = {
  columnsLength: 0,
  emptyIcon: undefined,
  emptyTitle: undefined,
  emptyDescription: undefined
};